import React, { useState } from "react";
import useFinancialTransactions from "../../hooks/useFinancialTransactions";
import { TRANSACTION_TYPES } from "../../constants/transactionTypes";
import TransactionForm from "./TransactionForm";
import TransactionTable from "./TransactionTable";
import ConfirmDialog from "../ConfirmDialog/ConfirmDialog";
import styles from "./RevenueTab.module.css";

const RevenueTab = () => {
  const {
    transactions,
    loading,
    error,
    createTransaction,
    updateTransaction,
    deleteTransaction,
  } = useFinancialTransactions(TRANSACTION_TYPES.REVENUE);

  const [editingItem, setEditingItem] = useState(null);
  const [showForm, setShowForm] = useState(false);

  // حذف
  const [itemToDelete, setItemToDelete] = useState(null);
  const [deleting, setDeleting] = useState(false);

  const handleSubmit = async (data) => {
    if (editingItem) {
      await updateTransaction(editingItem.id, data);
    } else {
      await createTransaction(data);
    }
    setShowForm(false);
    setEditingItem(null);
  };

  const handleEdit = (item) => {
    setEditingItem(item);
    setShowForm(true);
  };

  // فتح نافذة التأكيد
  const handleDelete = (item) => {
    setItemToDelete(item);
  };

  // تنفيذ الحذف
  const confirmDelete = async () => {
    if (!itemToDelete) return;

    try {
      setDeleting(true);
      await deleteTransaction(itemToDelete.id);
      setItemToDelete(null);
    } finally {
      setDeleting(false);
    }
  };

  // إلغاء الحذف
  const cancelDelete = () => {
    if (deleting) return;
    setItemToDelete(null);
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h3>الإيرادات</h3>
        <button onClick={() => { setEditingItem(null); setShowForm(true); }}>
          + إضافة الإيرادات
        </button>
      </div>

      {error && <p className={styles.error}>{error}</p>}

      {showForm && (
        <TransactionForm
          initialData={editingItem}
          onSubmit={handleSubmit}
          onCancel={() => { setShowForm(false); setEditingItem(null); }}
          submitLabel={editingItem ? "تحديث" : "إضافة"}
        />
      )}

      <TransactionTable
        transactions={transactions}
        loading={loading}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />

      <ConfirmDialog
        isOpen={!!itemToDelete}
        title="تأكيد الحذف"
        message={`هل أنت متأكد من حذف "${
          itemToDelete?.title || itemToDelete?.name || "هذا العنصر"
        }"؟ لا يمكن التراجع عن هذا الإجراء.`}
        loading={deleting}
        onConfirm={confirmDelete}
        onCancel={cancelDelete}
      />
    </div>
  );
};

export default RevenueTab;